module.exports = __webpack_public_path__ + "static/media/回鍋肉.10389cbe.jpg";